import backofficeService from "../../api/backoffice";

function randomAccessCode() {
  const bytes = new Uint8Array(12);

  if (window.crypto && window.crypto.getRandomValues) {
    window.crypto.getRandomValues(bytes);
  } else {
    for (let index = 0; index < bytes.length; index += 1) {
      bytes[index] = Math.floor(Math.random() * 256);
    }
  }

  return Array.from(bytes)
    .map((value) => value.toString(16).padStart(2, "0"))
    .join("")
    .toUpperCase();
}

export default {
  getAll(params = {}) {
    return backofficeService
      .Api()
      .get("inboundDeliveryPerson", { params })
      .then((response) => response.data);
  },

  getById(id) {
    return backofficeService
      .Api()
      .get(`inboundDeliveryPerson/${id}`)
      .then((response) => response.data);
  },

  create(data) {
    return backofficeService
      .Api()
      .post("inboundDeliveryPerson", data)
      .then((response) => response.data);
  },

  update(id, data) {
    return backofficeService
      .Api()
      .put(`inboundDeliveryPerson/${id}`, data)
      .then((response) => response.data);
  },

  delete(id) {
    return backofficeService
      .Api()
      .delete(`inboundDeliveryPerson/${id}`)
      .then((response) => response.data);
  },

  generateAccessCode() {
    return randomAccessCode();
  },

  getDeliveryLink(accessCode) {
    const code = encodeURIComponent(accessCode || "");
    return `${window.location.origin}/p/delivery/${code}`;
  },
};
